export default __webpack_public_path__ + "static/media/12.bcfe2e25.jpg";